import { Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import SearchTreeTopLine from '@/components/shared/searchTree/SearchTreeTopLine';
import Loader from '@/components/ui/Loader';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import SearchItems from './SearchItems';

import s from './SearchContent.module.scss';

type SearchContentProps = {
  withSelection?: boolean;
};

const SearchContent: React.FC<SearchContentProps> = ({ withSelection = false }) => {
  const {
    searchDocumentStore: { meta, totalDocuments, sortBy, setSortBy },
  } = useSidebarDocumentsStore();

  if (meta.isLoading) {
    return <Loader fullHeight type="dots" size="xl" text="Ищу документы..." />;
  }

  if (meta.isError) {
    return <Alert color="red" icon={<IconAlertCircle />} title="Ошибка запроса. Попробуйте ещё раз" />;
  }

  return (
    <div className={s.root}>
      <SearchTreeTopLine totalDocuments={totalDocuments} sortBy={sortBy} onSortChange={setSortBy} />
      <SearchItems withSelection={withSelection} />
    </div>
  );
};

export default observer(SearchContent);
